module.exports = __webpack_public_path__ + "img/thumbnail_DamaGazelle_j_normal.b05a2a04.png";